import React from "react";
import { NavLink, Outlet, useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { LayoutDashboard, Ticket, Gift, User as UserIcon, LogOut, Home } from "lucide-react";
import LangDropdown from "@/components/site/LangDropdown";
import "./client-portal.css";

const NAV = [
  { to: "/client-portal", label: "Painel", icon: LayoutDashboard, end: true, key: "painel" },
  { to: "/client-portal/bookings", label: "Reservas", icon: Ticket, key: "reservas" },
  { to: "/client-portal/referrals", label: "Convidados", icon: Gift, key: "convidados" },
  { to: "/client-portal/profile", label: "Perfil", icon: UserIcon, key: "perfil" },
];

/**
 * Client Portal shell — mirrors the landing page aesthetic (navy + gold, Playfair headings).
 * Used for the 4 pages accessible from the 3-dot menu on /app.
 */
export default function ClientPortalShell() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <div className="cp-shell" data-testid="client-portal-shell">
      <header className="cp-header" data-testid="cp-header">
        <div className="cp-header__inner">
          <Link to="/app" className="cp-logo" data-testid="cp-logo">
            DI<span className="g">TOURS</span>
          </Link>

          <nav className="cp-tabs" data-testid="cp-tabs">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                data-testid={`cp-tab-${item.key}`}
                className={({ isActive }) => `cp-tab ${isActive ? "is-active" : ""}`}
              >
                <item.icon /> {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="cp-user">
            <span className="cp-user__name" data-testid="cp-user-name">{user?.name || ""}</span>
            <LangDropdown testId="cp-lang" />
            <Link to="/app" className="cp-btn-ghost" data-testid="cp-back-to-site" title="Voltar ao site">
              <Home size={13} />
            </Link>
            <button
              type="button"
              onClick={async () => { await logout(); nav("/login"); }}
              className="cp-btn-ghost"
              data-testid="cp-logout"
            >
              <LogOut size={13} /> Sair
            </button>
          </div>
        </div>
      </header>

      <main className="cp-main">
        <Outlet />
      </main>
    </div>
  );
}
